import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';

const normalizeBoolean = value => {
  if (value === "true") {
    return true;
  }

  if (value === "false") {
    return false;
  }

  return value;
};

let Edit = props => {
  const { handleSubmit, companies, callcenters, roles } = props;
  return (
    <form className="ScForm" onSubmit={handleSubmit}>
      <div>
        <h2>Ред. пользователя</h2>
        <div>
          <label>Имя</label>
          <Field name="name" component="input" type="text" placeholder="" data-lpignore />
        </div>

      </div>
      <div>
        <label>Email</label>
        <Field name="email" component="input" type="text" placeholder="" data-lpignore />
      </div>
      <div className="ScFormRow_50">
        <div>
          <label>Юркомпания</label>
          <Field
            name="companyId"
            component="select"
          >
            <option key='none' value="novalue">Не выбрано</option>
            {companies.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
          </Field>
        </div>
      </div>

      <div>
        <label>Пароль</label>
        <Field name="password" component="input" type="password" placeholder="" data-lpignore />
      </div>

      <div className="ScFormRow_50">
        <label>Уволен</label>
        <Field name="fired" component="select" normalize={normalizeBoolean}>
          <option value={true}>Да</option>
          <option value={false}>Нет</option>
        </Field>
      </div>
      <div>
        <button type="submit">
            Сохранить
        </button>
      </div>
    </form>
  );
};

Edit = reduxForm({
  form: 'editPayment'
})(Edit);

Edit = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
}))(Edit);

export default Edit;



// WEBPACK FOOTER //
// ./src/pages/callcenter/users/Edit.js